var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data.colors.length > 0
    ? _c("div", { staticClass: "product-item__colors" }, [
        _c(
          "p",
          { staticClass: "visually-hidden", attrs: { id: _vm.identifier } },
          [_vm._v("\n    " + _vm._s(_vm.colorText) + "\n  ")]
        ),
        _vm._v(" "),
        _vm.data.onPlp
          ? _c(
              "ul",
              {
                staticClass: "product-item__colors-list d-flex",
                attrs: { "aria-labelledby": _vm.identifier }
              },
              _vm._l(_vm.data.colors, function(color, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "product-item__colors-item",
                    on: {
                      click: function($event) {
                        return _vm.data.updateProduct(color)
                      }
                    }
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "d-flex",
                        class: _vm.getSwatchClasses(color),
                        attrs: {
                          "aria-label": _vm.getColorString(
                            color.swatch.color_name
                          )
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: color.swatch.url,
                            alt: _vm.getColorString(color.swatch.color_name)
                          }
                        })
                      ]
                    )
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.data.onPlp
          ? _c(
              "ul",
              {
                staticClass: "product-item__colors-list d-flex",
                attrs: { "aria-labelledby": _vm.identifier }
              },
              _vm._l(_vm.data.colors, function(color, index) {
                return _c(
                  "li",
                  { key: index, staticClass: "product-item__colors-item" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "d-flex",
                        class: _vm.getSwatchClasses(color),
                        attrs: {
                          href: color.url,
                          "aria-label": _vm.getColorString(
                            color.swatch.color_name
                          )
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: color.swatch.url,
                            alt: _vm.getColorString(color.swatch.color_name)
                          }
                        })
                      ]
                    )
                  ]
                )
              }),
              0
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }